import { createContext, ReactNode, useState, useMemo, useCallback } from 'react';

type NavBreadcrumbProviderProps = {
  readonly children: ReactNode;
};

export type BreadcrumbItem = { path?: string; title: string | ReactNode };

type NavBreadcrumbContextType = {
  items: BreadcrumbItem[];
  setItems: (items: BreadcrumbItem[]) => void;
};

export const NavBreadcrumbContext = createContext<NavBreadcrumbContextType>({
  items: [],
  setItems: () => {},
});

export function NavBreadcrumbProvider({ children }: NavBreadcrumbProviderProps) {
  const [items, setItemsState] = useState<BreadcrumbItem[]>([]);

  const setItems = useCallback((newItems: BreadcrumbItem[]) => {
    setItemsState(newItems);
  }, []);

  const contextValue = useMemo(() => ({ items, setItems }), [items, setItems]);

  return <NavBreadcrumbContext.Provider value={contextValue}>{children}</NavBreadcrumbContext.Provider>;
}
